export interface SalonPublicUrlInput {
  salonId: string;
  slug?: string | null;
}

export interface PublicAppUrlOptions extends SalonPublicUrlInput {
  baseDomain: string;
}

export class PublicUrlUtils {
  public static appUrlWithoutSubdomain(baseDomain: string): string {
    return `https://app.${baseDomain}`;
  }

  public static appUrlWithSubdomain(slug: string, baseDomain: string): string {
    return `https://${slug}.app.${baseDomain}`;
  }

  public static salonPublicBaseUrl(options: PublicAppUrlOptions): string {
    if (options.slug) {
      return this.appUrlWithSubdomain(options.slug, options.baseDomain);
    }
    return `${this.appUrlWithoutSubdomain(options.baseDomain)}/s/${options.salonId}`;
  }

  public static salonPublicUrl(options: PublicAppUrlOptions, path?: string, queryParams?: Record<string, string>): string {
    const normalizedPath = path ? `/${path.replace(/^\/+/, '').replace(/\/+/g, '/')}` : '';
    const paramsStr = new URLSearchParams(queryParams ?? {}).toString();
    const query = paramsStr ? `?${paramsStr}` : '';
    return `${this.salonPublicBaseUrl(options)}${normalizedPath}${query}`;
  }
}